import { IPaginationParams, IPaginationResponse } from '../models/interfaces/pagination';
import apiService from './api';
import { IOrder } from "../types/IOrder";
import { IVehicle } from "../types/IVehicle";

export class FleetsService {
  public listOrders(params: IPaginationParams): Promise<IPaginationResponse<IOrder[]>> {
    return apiService.get('/order', { params });
  }

  public ordersReport(params: IPaginationParams) {
    return apiService.get('/order/download-report', { responseType: 'blob', headers: { 'Accept': 'application/vnd.ms-excel' }, params });
  }

  public listVehicles(params: IPaginationParams): Promise<IPaginationResponse<IVehicle[]>> {
    return apiService.get('/vehicle', { params });
  }

}

const fleetsService = new FleetsService();
export default fleetsService;
